import { createFileRoute, redirect } from '@tanstack/react-router';

/** Email templates moved to Tools; keep old links working. */
export const Route = createFileRoute(
  '/_private/_route/_internal/events/settings/',
)({
  beforeLoad: () => {
    throw redirect({ to: '/tools/email-templates' });
  },
});
